<template>
    <!-- 底部 -->
    <div>
        <div class="indexmaxlisfour w1750 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
            <div class="cont w1366">
                <div class="mk wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                   <div class="titlebox titlebox2">
                        <div class="h">和我们取得联系</div>
                        <div class="p">如果您还想了解更详细的开发需求，请在线咨询，我们为你提供专业的方案指导以及报价详情！</div>
                    </div> 
                    <div class="list">
                        <div class="left">
                            <div class="wear">
                                <div class="m"><img src="../assets/img/Qr.jpg" alt=""></div>
                                <div class="p">添加微信咨询</div>
                            </div>
                            <div class="ter">
                                <div class="h">预约面谈</div>
                                <div class="p">可以通过以下方式与我们联系（师经理）</div>
                                <div class="tel">0931-4632419<br/>18919819927</div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="h">输入您的电话号码提交给我们</div>
                            <el-form :model="loginForms" :rules="loginFormRuless" ref="ruleFormRefs" label-width="">
                                <div class="input">
                                    <!-- <input type="text" placeholder="输入11位手机号码"> -->
                                    <el-form-item label="" prop="phone">
                                        <el-input v-model="loginForms.phone" placeholder="请填写11位手机号"></el-input>
                                    </el-form-item>
                                    <!-- <button type="button">提交联系方式</button> -->
                                    <el-button type="primary" @click="submitForms">提交联系方式</el-button>
                                </div>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="cont w1366 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                <div class="toop">
                    <div class="wli">
                        <div class="h"><i>WEB开发</i></div>
                        <div class="min">
                            <div class="li"><i>高端网站建设</i></div>
                            <div class="li"><i>移动端H5</i></div>
                            <div class="li"><i>B/S架构应用系统</i></div>
                            <div class="li"><i>可视化数据看版</i></div>
                        </div>
                    </div>
                    <div class="wli">
                        <div class="h"><i>APP开发</i></div>
                        <div class="min">
                            <div class="li"><i>Android开发</i></div>
                            <div class="li"><i>IOS开发</i></div>
                        </div>
                    </div>
                    <div class="wli">
                        <div class="h"><i>微信开发</i></div>
                        <div class="min">
                            <div class="li"><i>公众号开发</i></div>
                            <div class="li"><i>小程序开发</i></div>
                            <div class="li"><i>企业微信开发</i></div>
                        </div>
                    </div>
                    <div class="wli">
                        <div class="h"><i>云产品</i></div>
                        <div class="min">
                            <div class="li"><i>域名</i></div>
                            <div class="li"><i>云服务器</i></div>
                            <div class="li"><i>SSL安全证书</i></div>
                            <div class="li"><i>云存储</i></div>
                            <div class="li"><i>CDN加速</i></div>
                            <div class="li"><i>API</i></div>
                            <div class="li"><i>数据库</i></div>
                            <div class="li"><i>安全运维</i></div>
                        </div>
                    </div>
                    <div class="wli">
                        <div class="h"><i>关于我们</i></div>
                        <div class="min">
                            <div class="li"><i>关于有众</i></div>
                            <div class="li"><i>资讯观点</i></div>
                            <div class="li"><i>联系我们</i></div>
                        </div>
                    </div>
                    <div class="wli">
                        <div class="h"><i>联系我们</i></div>
                        <div class="tel">
                            <div class="m">中国 兰州</div>
                            <div class="p">甘肃省兰州市城关区定西路八冶大厦C2205（商务厅对面，甘肃银行楼上）</div>
                            <div class="mapbox">
                                <div class="icon"><img src="../assets/6.png" alt="">地图位置</div>
                                <div class="mapup">
                                    <maxmap></maxmap>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wli">
                        <div class="h"><i>客户端</i></div>
                        <div class="wear">
                            <div class="li li1">
                                <div class="m"><img src="" alt=""></div>
                                <div class="p">微信小程序</div>
                                <div class="img">
                                    <img src="../assets/images/qr5.jpg" alt="">
                                </div>
                            </div>
                            <div class="li li2">
                                <div class="m"><img src="" alt=""></div>
                                <div class="p">百度小程序</div>
                                <div class="img">
                                    <img src="../assets/images/qr4.png" alt="">
                                </div>
                            </div>
                            <div class="li li3">
                                <div class="m"><img src="" alt=""></div>
                                <div class="p">H5端</div>
                                <div class="img">
                                    <img src="../assets/images/qr3.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="boot">
                    <div class="left">
                        <div class="p" @click="openurl('https://beian.miit.gov.cn')">© 2024 GSYZKJ.COM.All rights reserved.  陇ICP备17002969号-1</div>
                        <div class="p p1" @click="openurl('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62010202001727')">甘公网安备 62010202001727号</div>
                    </div>
                    <div class="a">power by 甘肃有众信息科技有限公司</div>
                </div>
            </div>
        </div> 
        <!--  -->
        <div class="minkNaver">
            <div class="li">
                <a target="_blank" href="https://p.qiao.baidu.com/cps4/chatIndex?siteToken=fa6b3d5361002f77431328216553694d&amp;speedLogId=162158902992349c1_1621589029923_10949&amp;eid=25401671&amp;reqParam=%7B%22from%22%3A0%2C%22sid%22%3A%22-100%22%2C%22tid%22%3A%22-1%22%2C%22ttype%22%3A1%2C%22siteId%22%3A%2211856238%22%2C%22userId%22%3A%2225401671%22%2C%22pageId%22%3A0%7D">
                    <div class="img info"></div>
                    <div class="p">在线咨询</div>
                </a>
            </div>
            <div class="li">
                <a href="javascript:;">
                    <div class="img tel"></div>
                    <div class="p">电话咨询</div>
                </a>
                <div class="mik">
                    <div class="h1" style="font-size:16px ;">咨询热线</div>
                    <div class="p">0931-4632419<br>18919819927</div>
                </div>
            </div>
            <div class="li">
                <a href="javascript:;">
                    <div class="img weah"></div>
                    <div class="p">微信咨询</div>
                </a>
                <div class="mik">
                    <div class="h2">微信扫码，1对1沟通</div>
                    <img src="../assets/images/qr4.png" alt="" class="Qr">
                </div>
            </div>
            <div class="li">
                <a href="javascript:;">
                    <div class="img top"></div>
                    <div class="p">回到顶部</div>
                </a>
            </div>
        </div>
        <!--  -->
         <swiperbox></swiperbox>
    </div>
</template>

<script>
    import swiperbox from './swiper.vue'
    import maxmap from './mapbox.vue'
    
    export default {
        data() {
            // 定义表单数据和验证规则
            var validatePhoneNumbers = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号码不能为空'));
                } else if (!/^1[3-9]\d{9}$/.test(value)) {
                    callback(new Error('请输入正确的手机号码'));
                } else {
                    callback();
                }
            };
            return {
                loginForms: {
                    phone: ''
                },
                loginFormRuless: {
                    phone: [
                        { required: true, message: '请输入您的11位手机号', trigger: 'blur' },
                        { validator: validatePhoneNumbers }
                    ]
                }
            }
        },
        methods: {
			openurl(url){
			    window.open(url)
			},
            submitForms() {
                this.$refs.ruleFormRefs.validate(async valid => {
                    if (valid) {
                        const { data: res } = await this.$http.post('/api/demand', this.loginForms )
                        if( res.code == 200 ){
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            });
                            this.$refs.ruleFormRefs.resetFields();
                            // window.location.reload();
                        }
                        
                    } else {
                        
                        return false;
                    }
                });
            }
        },
        components: {
        	swiperbox, maxmap
        }
    }
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?66385605a29686fc3fcbba7e708ec372";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
</script>
<style>
</style>